/* Carry an explicit storefront through a shared checkout domain. No buyer data. */
(function () {
  'use strict';
  var host = window.location.hostname.toLowerCase();
  if (!/^(es\.|www\.)?mosaikasa\.com$/.test(host)) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var pending;
  function save() {
    if (pending) return pending;
    pending = fetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _mosaikasa_storefront: host } })
    }).then(function (response) {
      if (!response.ok) throw new Error('Storefront handoff failed');
    }).catch(function () {
      // Keep checkout usable on failure. The pixel fails closed without origin.
    }).finally(function () { pending = null; });
    return pending;
  }
  save();
  // Accelerated checkout must be validated separately; never guess its origin.
  var resumed = false;
  document.addEventListener('click', function (event) {
    if (resumed || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    var target = event.target.closest('a[href], button[name="checkout"], input[name="checkout"]');
    if (!target) return;
    if (target.tagName === 'A') {
      var url = new URL(target.href, window.location.href);
      if (url.origin !== window.location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    Promise.race([save(), new Promise(function (resolve) { setTimeout(resolve, 1500); })]).then(function () {
      resumed = true;
      try { target.click(); } finally { resumed = false; }
    });
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.action || !/\/cart\/?$/.test(new URL(form.action, window.location.href).pathname)) return;
    var input = form.querySelector('[name="attributes[_mosaikasa_storefront]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'attributes[_mosaikasa_storefront]';
      form.appendChild(input);
    }
    input.value = host;
  }, true);
})();
